class PromoterDelegate {
    setDate(date) {
        this.setState((prevState) => {
            return { date };
        });
    }

    setDateRange(dateRange) {
        this.setState((prevState) => {
            return { dateRange };
        });
    }

    setFilterMode(filterMode) {
        this.setState((prevState) => {
            return { filterMode };
        });
    }

    setTrendRange(trendRange) {
        this.setState((prevState) => {
            return { trendRange };
        });
    }

    setTrendWeekday(trendWeekday) {
        this.setState((prevState) => {
            return { trendWeekday };
        });
    }

    setLoading(loading) {
        this.setState((prevState) => {
            return { loading };
        });
    }

    setIsOpen(isOpen) {
        this.setState((prevState) => {
            return { isOpen };
        });
    }
}

export default PromoterDelegate;
